import "firebase/auth";
import "firebase/firestore";
import "firebase/functions";

import "./src/style/style.scss";

import { Box, ChakraProvider } from "@chakra-ui/react";
import {
  ShouldUpdateScrollArgs,
  WrapPageElementBrowserArgs,
  WrapRootElementBrowserArgs,
} from "gatsby";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import theme from "src/theme/theme";
import { AuthReadyGate } from "./src/components/AuthReadyGate";
import { persistor, store } from "./src/lib/redux/store";

export const wrapRootElement = ({ element }: WrapRootElementBrowserArgs) => {
  return (
    <ChakraProvider theme={theme}>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <AuthReadyGate>{element}</AuthReadyGate>
        </PersistGate>
      </Provider>
    </ChakraProvider>
  );
};

type ScrollState = undefined | boolean | "smooth";

export const onRouteUpdate = () => {
  document.documentElement.lang = "en";
};

export const shouldUpdateScroll = (args: ShouldUpdateScrollArgs) => {
  const scroll = args.routerProps.location.state?.scroll as ScrollState;
  if (scroll === true || scroll === undefined) return true;
  if (scroll === false) return false;

  // Smooth scroll
  if (scroll === "smooth") {
    const top = (args.routerProps.location.state?.top as number) ?? 0;
    window.scrollTo({ top, behavior: "smooth" });
    return false;
  }
};

// export const onRouteUpdate = ({ location, prevLocation }) => {
//   window.onpopstate = function (event) {
//     // Prevent the default behavior of the back button
//     window.history.forward();
//   };
// };

export const wrapPageElement = (
  args: WrapPageElementBrowserArgs,
): React.ReactElement => {
  if (!("section" in args.props.params)) return args.element;
  const isQuestionPage =
    !args.props.path.endsWith("confirm") && !args.props.path.endsWith("start");
  return (
    <Box
      {...args.props}
      bgGradient={"linear(purple.500 0%, gray.100 800px)"}
      backgroundPosition={!isQuestionPage ? "top" : "bottom"}
      backgroundSize={"200% 200%"}
      transition={"background-position 500ms ease-in-out 0ms"}
      _dark={{
        bgGradient: "linear(purple.700 0%, gray.950 800px)",
      }}
    >
      {args.element}
    </Box>
  );
};
